import React from "react"
import "./title.css"
export const Title = ({text}) => {
    return <><h2 className="app-title">{text}</h2></>
}